import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Chart } from 'chart.js';
import { Statistics } from 'src/app/interfaces/statistics';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';

@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.page.html',
  styleUrls: ['./estadisticas.page.scss'],
})
export class EstadisticasPage implements OnInit {

  formRight: FormGroup;
  formLeft: FormGroup;
  statistics: any = { left: {}, right: {}};
  keysPrecioMedioPorRepartidor: any;

  statisticsLeftReady = false;
  statisticsRightReady = false;

  metricsSession = [
    'Nº DE SESIONES',
    'FACTURACIÓN MEDIA POR SESIÓN',
    'Nº DE SERVICIOS',
    'FACTURACIÓN MEDIA POR SERVICIO'
  ];
  metricsSessionVars = [
    'numSessions',
    'avgFacturacionSession',
    'numServices',
    'avgFacturacionService'
  ];

  metricsClientSession = [
    'MAYOR FACTURACION',
    'MAYOR VENTA',
    'MAYORES ENTREGAS'
  ];

  metricsClientSessionVars = [
    'clientWithMostFacturacion',
    'clientWithMostUds',
    'clientWithMostServices'
  ];

  products = ['ALQUILER CAMARAS',
              'BARRA',
              'BLOQUES',
              'CUBITO SCOTSMAN',
              'CUBITO VOGT',
              'DESPLAZAMIENTO',
              'ESCAMA CUAD',
              'ESCAMA RED',
              'HIELO CUADRADO',
              'HIELO ESPECIAL',
              'HIELO PILEE',
              'HIELO SECO',
              'CUBO 5X5',
              'LINGOTE 4X12',
              'ESFERAS 6CM',
              'CUBO 5,5 X 5,5',
              'CUBO 5X7',
              'LINGOTE 3X15',
              'ESFERAS 3CM',
              'TOTAL'];

  constructor(
    private rest: RestService,
    private utils: UtilsService,
    private fb: FormBuilder
  ) {
    this.formRight = this.fb.group({
      startDate: [null, null],
      endDate: [null, null]
    });
    this.formLeft = this.fb.group({
      startDate: [null, null],
      endDate: [null, null]
    });
  }

  async search(column: string) {
    try {
      await this.utils.showLoading();
      this.statistics = { left: {}, right: {}};
      this.statisticsLeftReady = false;
      this.statisticsRightReady = false;
      console.log(this.formLeft.value);

      const form = column === 'right' ? this.formRight.value : this.formLeft.value;

      const resp = await this.rest.getRangeStatistics(form.startDate.split('T')[0], form.endDate.split('T')[0]);
      await this.utils.hideLoading();
      console.log('Statistics:');
      console.log(resp);
      if (resp && resp.body) {
        this.statistics[column] = resp.body as Statistics;
        this.keysPrecioMedioPorRepartidor = Object.keys(this.statistics[column].precioMedioPorRepartidor);
        console.log('statistics');
        console.log(this.statistics[column]);
        if (column === 'right') {
          this.statisticsRightReady = true;
        } else {
          this.statisticsLeftReady = true;
        }
      } else {
        await this.utils.showToast('Hubo un error en la búsqueda', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Hubo un error en la búsqueda', 'danger');
    }
  }

  ngOnInit() {
    registerLocaleData( es );
  }


}
